module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/customer/customer-12-87162079bbbc3d336264c0334bb55459.jpg";